<div class="container">
  <div id="pageLoaderDiv" class="page-loader page-loader-semi-transparent" *ngIf="!error">
    <div class="centered-div-outer">
      <div class="centered-div-middle">
        <div class="centered-div-inner opening-page">
          <div class="loadingFileSpinner"></div>
          <div>{{'OpeningPage' | translate}}…</div>
        </div>
      </div>
    </div>
  </div>
</div>
